import ProgramLicensesSelector from './ProgramLicensesSelector';

export default ProgramLicensesSelector;
